import axios from 'axios'

const SoftphoneService = {
  async mySoftphone() {
    return axios.get('user/my-softphone')
  }
}

export default SoftphoneService
